export default {
    SNACKBAR_SUCCESS: 'SNACKBAR_SUCCESS',
    SNACKBAR_ERROR: 'SNACKBAR_ERROR',
    SNACKBAR_WARNING: 'SNACKBAR_WARNING',
    SNACKBAR_INFO: 'SNACKBAR_INFO',
}